import { Navbar, NavbarBrand, NavbarContent, NavbarItem, Link, Button, Image, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from "@heroui/react";
import { 
  HomeIcon, 
  UserGroupIcon, 
  UsersIcon,
  CogIcon, 
  BellIcon,
  ArrowRightOnRectangleIcon,
  UserIcon,
  ChevronDownIcon
} from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { getUserDisplayName, getUserInitials } from "../../utils/auth";
import UserAvatar from "../UserAvatar/UserAvatar";
import pivotLogo from "../../assets/pivot.jpeg";

export const PivotPTLogo = () => {
  return (
    <div className="flex items-center gap-3">
      <Image
        alt="Pivot PT Logo"
        height="40"
        width="120"
        src={pivotLogo}
        className="rounded-lg"
      />
      <div className="hidden sm:block">
        <div className="text-sm text-gray-500">by</div>
        <div className="text-xs font-semibold text-gray-700">TURINGSENSE</div>
      </div>
    </div>
  );
};

export default function TopNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  return (
    <Navbar 
      isBordered 
      className="bg-white/80 backdrop-blur-md border-b border-gray-200 shadow-sm"
      maxWidth="full"
    >
      <NavbarBrand className="gap-4">
        <PivotPTLogo />
      </NavbarBrand>
      
      <NavbarContent className="flex gap-6" justify="center">
        <NavbarItem>
          <Link 
            href="/dashboard" 
            className={`flex items-center gap-2 transition-colors ${
              location.pathname === "/dashboard" 
                ? "text-blue-600 font-semibold" 
                : "text-gray-700 hover:text-blue-600"
            }`}
          >
            <HomeIcon className="w-5 h-5" />
            <span className="font-medium">Dashboard</span>
          </Link>
        </NavbarItem>
        <NavbarItem>
          <Link 
            href="/" 
            className={`flex items-center gap-2 transition-colors ${
              location.pathname === "/" 
                ? "text-blue-600 font-semibold" 
                : "text-gray-700 hover:text-blue-600"
            }`}
          >
            <UserGroupIcon className="w-5 h-5" />
            <span>Exercise Management</span>
          </Link>
        </NavbarItem>
        <NavbarItem>
          <Link 
            href="/users" 
            className={`flex items-center gap-2 transition-colors ${
              location.pathname === "/users" 
                ? "text-blue-600 font-semibold" 
                : "text-gray-700 hover:text-blue-600"
            }`}
          >
            <UsersIcon className="w-5 h-5" />
            <span className="font-medium">User Management</span>
          </Link>
        </NavbarItem>
        <NavbarItem>
          <Link 
            href="#" 
            className="flex items-center gap-2 text-gray-700 hover:text-blue-600 transition-colors"
          >
            <CogIcon className="w-5 h-5" />
            <span className="font-medium">Settings</span>
          </Link>
        </NavbarItem>
      </NavbarContent>
      
      <NavbarContent justify="end">
        <NavbarItem>
          <Button
            isIconOnly
            variant="light"
            className="text-gray-600 hover:text-blue-600"
          >
            <BellIcon className="w-5 h-5" />
          </Button>
        </NavbarItem>
        <NavbarItem>
          {isAuthenticated && user ? (
            <Dropdown placement="bottom-end">
              <DropdownTrigger>
                <Button
                  variant="light"
                  className="p-0 bg-transparent data-[hover=true]:bg-gray-100"
                >
          <div className="flex items-center gap-3">
            <div className="hidden sm:block text-right">
                      <div className="text-sm font-semibold text-gray-900">
                        {getUserDisplayName(user)}
                      </div>
                      <div className="text-xs text-gray-500">
                        {user.name || 'User'}
                      </div>
                    </div>
                    <UserAvatar 
                      user={user} 
                      size="md" 
                      showBorder={true}
                    />
                    <ChevronDownIcon className="w-4 h-4 text-gray-500" />
                  </div>
                </Button>
              </DropdownTrigger>
              <DropdownMenu aria-label="User menu">
                <DropdownItem
                  key="profile"
                  startContent={<UserIcon className="w-4 h-4" />}
                  className="text-gray-700"
                >
                  Profile
                </DropdownItem>
                <DropdownItem
                  key="settings"
                  startContent={<CogIcon className="w-4 h-4" />}
                  className="text-gray-700"
                >
                  Settings
                </DropdownItem>
                <DropdownItem
                  key="logout"
                  startContent={<ArrowRightOnRectangleIcon className="w-4 h-4" />}
                  className="text-danger"
                  color="danger"
                  onPress={handleLogout}
                >
                  Logout
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          ) : (
            <div className="flex items-center gap-3">
              <div className="hidden sm:block text-right">
                <div className="text-sm font-semibold text-gray-900">Guest</div>
                <div className="text-xs text-gray-500">Not logged in</div>
              </div>
              <UserAvatar 
                user={null} 
                size="md" 
                showBorder={false}
              />
            </div>
          )}
        </NavbarItem>
      </NavbarContent>
    </Navbar>
  );
}
